import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Box, Button, CardActionArea } from '@mui/material';
import { listPublic, type RodoDocumentDto } from '../services/rodoDocumentsService';

const DocumentsPage: React.FC = () => {
  const [docs, setDocs] = React.useState<RodoDocumentDto[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      try {
        const data = await listPublic();
        const sorted = (data || []).slice().sort((a:any,b:any)=>{
          const sa = (a?.sort_order ?? 100);
          const sb = (b?.sort_order ?? 100);
          if (sa !== sb) return sa - sb;
          return String(b?.created_at||'').localeCompare(String(a?.created_at||''));
        });
        setDocs(sorted);
      } catch { setDocs([]); } finally { setLoading(false); }
    })();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Logo */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0 }}>
        <Typography
          component="span"
          sx={{
            fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
            fontWeight: 600,
            fontSize: '21.94px',
            lineHeight: '26px',
            letterSpacing: '0.12em',
            color: 'rgba(197, 48, 48, 1)',
            width: '140px',
            height: '26px',
            display: 'inline-block'
          }}
        >
          UNITRESCO
        </Typography>
      </Box>
      {/* Tytuł */}
      <Typography
        component="h1"
        sx={{
          fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
          fontWeight: 600,
          fontSize: '48px',
          lineHeight: '100%',
          letterSpacing: 0,
          color: 'rgba(2, 2, 66, 1)',
          mt: '60px',
          mb: '25px'
        }}
      >
        Dokumenty
      </Typography>

      {loading ? (
        <Typography>Ładowanie…</Typography>
      ) : (
        <Grid container spacing={3}>
          {docs.map((d) => (
            <Grid item xs={12} md={6} lg={4} key={d.id} sx={{ display: 'flex' }}>
              <Card
                variant="outlined"
                sx={{
                  width: '384px',
                  minHeight: '210px',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: '4px',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: 'rgba(2, 2, 66, 1)',
                  padding: '20px',
                  gap: '24px',
                  transition: 'border-color .2s ease, box-shadow .2s ease',
                  '&:hover': { borderColor: '#010144', boxShadow: '0 0 0 1px rgba(2, 2, 66, 0.6)' }
                }}
              >
                <CardActionArea component="div" onClick={() => d.file_url && window.open(d.file_url, '_blank', 'noopener,noreferrer')} sx={{ borderRadius: '4px', cursor: 'pointer' }}>
                  <CardContent sx={{ flexGrow: 1, p: 0 }}>
                    <Typography
                      gutterBottom
                      sx={{
                        fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
                        fontWeight: 600,
                        fontSize: '18px',
                        lineHeight: '100%',
                        color: 'rgba(2, 2, 66, 1)'
                      }}
                    >
                      {d.title_pl}
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                      <Typography variant="body2" color="text.secondary">
                        {d.file_url ? 'Plik PDF dostępny do pobrania' : 'Brak pliku'}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
                <Box sx={{ pt: 0 }}>
                  <Button
                    disabled={!d.file_url}
                    onClick={() => d.file_url && window.open(d.file_url, '_blank', 'noopener,noreferrer')}
                    sx={{
                      textTransform: 'none',
                      fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
                      fontWeight: 500,
                      fontSize: '14px',
                      lineHeight: '100%',
                      borderRadius: '4px',
                      padding: '12px 16px',
                      color: 'rgba(255, 255, 255, 1)',
                      backgroundColor: 'rgba(2, 2, 66, 1)',
                      transition: 'background-color .15s ease',
                      '&:hover': { backgroundColor: 'rgba(2, 2, 66, 0.78)' }
                    }}
                  >
                    Otwórz dokument
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
          {!docs.length && (
            <Grid item xs={12}>
              <Typography>Brak opublikowanych dokumentów.</Typography>
            </Grid>
          )}
        </Grid>
      )}
    </Container>
  );
};

export default DocumentsPage;


